export default __webpack_public_path__ + "static/media/feedBackBad.ea409609.svg";